module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTAwIiBoZWlnaHQ9IjgwMCIgdmlld0JveD0iMCAwIDIyIDE2Ij48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAwaDIydjE2SDB6Ii8+PGcgZmlsbD0iIzAwNjVCRCI+PHBhdGggZD0iTTYgMGg0djE2SDZ6Ii8+PHBhdGggZD0iTTAgNmgyMnY0SDB6Ii8+PC9nPjxnIGZpbGw9IiNFRDI5MzkiPjxwYXRoIGQ9Ik03IDBoMnYxNkg3eiIvPjxwYXRoIGQ9Ik0wIDdoMjJ2MkgweiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/fro.svg
// module id = e/Tr
// module chunks = 0